import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedSocialSecurityDocument,
  RemoveSocialSecurityMutation,
  RemoveSocialSecurityMutationVariables,
  RemoveSocialSecurityDocument,
} from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { resetPaginationField } from "@/store/paginationStore";

/**
 * Custom hook for removing a social security and handling the necessary cache updates.
 * @returns {Object} - Contains the removeSocialSecurityMutation function, loading state, and error state.
 */
export default function useRemoveSocialSecurityMutationHook(): {
  removeSocialSecurityMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [removeSocialSecurityMutation, { loading, error }] = useMutation<RemoveSocialSecurityMutation, RemoveSocialSecurityMutationVariables>(
    RemoveSocialSecurityDocument, {
      onCompleted: () => {
      // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedSocialSecurity");

        toast(CustomToastComponent, {
          toastId: "social-security-removed-success",
          data: {
            title: t("toasts.socialsecurityremovedsuccessfully"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: PaginatedSocialSecurityDocument,
          variables: {
            first: 10,
            after: null,
            currentPage: 0,
            filters: {
              activeFrom: null,
              value: null,
            },
            sort: null,
          },
        },
      ],
    });

  return {
    removeSocialSecurityMutation,
    loading,
    error,
  };
}
